import ModalButton from './components/ModalWindowButton'
import ModalContent from './components/ModalWindowContent'

console.log('ModalWIndow is depricated. Look in UI')

export { ModalButton, ModalContent }
